import { getLang } from '@/helpers/getLang'
import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type TCreateDto = {
    id?: number
    selectedVariant: string
    selectedRole: string
    modern?: string
    comfortable?: string
    information?: string
    comment?: string
    email?: string
    name?: string
    feedback?: boolean
}

export const testingApi = createApi({
    reducerPath: 'testingApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    endpoints: builder => ({
        create: builder.mutation<any, TCreateDto>({
            query: data => ({ url: `/testing`, method: 'POST', body: data })
        }),
        updateTesting: builder.mutation<any, Partial<TCreateDto>>({
            query: data => ({ url: `/testing`, method: 'PATCH', body: data })
        })
    })
})

export const { useCreateMutation, useUpdateTestingMutation } = testingApi
